import { FEATURE_FLAGS } from "@/helpers/FEATURE_FLAGS";
import { OpenFeature } from "@openfeature/web-sdk";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/captain-ai/$chatId")({
  staticData: {
    title: "apps.captain",
  },
  beforeLoad: async () => {
    const location = OpenFeature.getClient().getBooleanValue(FEATURE_FLAGS.Captain_Feature_Module_Enabled, false);
    if (!location) {
      throw redirect({ to: "/" });
    }

    await ensureRouteTranslationModuleLoaded("captain");
  },
});
